<template>
  <div>
    <div>
      <h2 class="flex flex-grow justify-start text-primary-500 font-bold">
        Helpful Contacts
      </h2>
    </div>


    <div v-if="mentors.length > 0" class="pt-10">
      <h3>Contact My Mentor(s)</h3>
      <p>
        Click the link(s) below to send a message to your mentor through Peer Link Pro
      </p>
      <div v-for="mentor in mentors" :key="mentor.id" @click="launchNotificationsModal(mentor)">
        <span class="cursor-pointer mt-2"><d-icon icon="envelope" class="w-5 mr-3" /><u>{{ mentor.fullName }}- {{ mentor.preferredEmail }}</u> </span>
      </div>
    </div>

    <div v-if="consultants.length > 0" class="pt-10">
      <h3>My Pathway Consultant</h3>
      <p>
        Click the link(s) below to send a message to your consultant(s) through Peer Link Pro
      </p>
      <div v-for="consultant in consultants" :key="consultant.id" @click="launchNotificationsModal(consultant)">
        <span class="cursor-pointer  mt-2"><d-icon icon="envelope" class="w-5 mr-3" /><u>{{ consultant.fullName }} - {{ consultant.preferredEmail }}</u> </span>
      </div>
    </div>


    <div class="pt-10">
      <h3>Need to Contact an Administrator?</h3>
      <p>Use the "Submit Feedback" option under the profile menu in the upper right to send feedback or questions directly to administrators, and we'll get back to you as soon as we can!</p>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  import axios from 'axios';
  import ViewNotificationModal from '@resources/scripts/patterns/ViewNotificationModal.vue';

  export default {
    parent: true,

    data: () => ({
      mentors: [],
      consultants: [],
    }),

    computed: {
      ...mapGetters('d2Auth', ['hasRole']),
    },

    mounted() {
      this.getMentors();
      this.getConsultants();
    },

    methods: {
      async getMentors() {
        const { data } = await axios.get('/api/contact/mentors');
        this.mentors = data;
      },
      async getConsultants() {
        const { data } = await axios.get('/api/contact/consultants');
        this.consultants = data;
      },

      launchNotificationsModal(user) {
        this.$modal.open({
          parent: this,
          component: ViewNotificationModal,
          hasModalCard: true,
          props: {
            entityId: user.id,
            type: 'user',
            name: user.fullName,
          },
        });
      },
    },
  };
</script>
